import React, { ReactNode, useMemo } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, ViewStyle } from 'react-native';
import { COLORS } from '../constants/config';
import { useTheme } from '../contexts/ThemeContext';

import { tokens } from '@design';
import { getTextAlign } from '../utils/rtl';
interface CardProps {
  children: ReactNode;
  title?: string;
  onPress?: () => void;
  style?: ViewStyle;
  headerRight?: ReactNode;
}

export default function Card({ children, title, onPress, style, headerRight }: CardProps) {
  const { colors } = useTheme();
  const Container = onPress ? TouchableOpacity : View;

  return (
    <Container
      style={[styles.card, { backgroundColor: colors.card, borderColor: colors.cardBorder, borderWidth: tokens.spacing.absolute["px"] }, style]}
      onPress={onPress}
      activeOpacity={0.7}
    >
      {title && (
        <View style={[styles.header, { borderBottomColor: colors.border }]}>
          <Text style={[styles.title, { color: colors.textPrimary }]}>{title}</Text>
          {headerRight}
        </View>
      )}
      <View style={styles.content}>{children}</View>
    </Container>
  );
}

const getStyles = (isRTL: boolean) => StyleSheet.create({
  card: {
    backgroundColor: COLORS.card,
    borderRadius: tokens.radii.absolute["radius-12"],
    // Use boxShadow for web compatibility
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    elevation: 3,
    marginBottom: tokens.spacing.absolute["3"],
  } as ViewStyle,
  header: {
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: tokens.spacing.absolute["4"],
    borderBottomWidth: tokens.spacing.absolute["px"],
    borderBottomColor: COLORS.border,
  },
  title: {
    fontSize: tokens.typography.paragraph["paragraph font size"],
    fontWeight: '600',
    color: COLORS.text,
    textAlign: getTextAlign(isRTL),
  },
  content: {
    padding: tokens.spacing.absolute["4"],
  },
});

const styles = getStyles(true);
